
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGround2On as ObiGround2OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ground-2-on.js';
 
 
 

 
 export const ObiGround2On = createComponent({
   react: React,
   tagName: 'obi-ground-2-on',
   elementClass: ObiGround2OnElement,
   events: {
     
   }
  });
 
 